var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("table", { staticClass: "table" }, [
      _c("caption", [_vm._v("\n    Cookies used by our pages\n  ")]),
      _vm._v(" "),
      _c("thead", [
        _c("tr", [
          _c("th", { attrs: { scope: "col" } }, [_vm._v("Location")]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [_vm._v("Classification")]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
          _vm._v(" "),
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v("What is it used for?"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v("App Dynamics")]),
          _vm._v(" "),
          _c("td", [_vm._v("Strictly Necessary")]),
          _vm._v(" "),
          _c("td", [_vm._v("ADRUM")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        PayPoint uses App Dynamics to collect information regarding how the\n        website is functioning and how the user interacts with the website, to\n        provide data on network management and accessibility of the website\n        for users.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Strictly Necessary")]),
          _vm._v(" "),
          _c("td", [_vm._v(".AspNet.SharedCookie")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        This cookie allows a user to login to the website provided valid\n        credentials have been supplied. Persists for a rolling 30 minute\n        window unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Strictly Necessary")]),
          _vm._v(" "),
          _c("td", [_vm._v("Token")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        Allows the user to visit pages within the website based on the login\n        credentials provided. Persists for the browser session unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Strictly Necessary")]),
          _vm._v(" "),
          _c("td", [_vm._v("isPilot")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        Allows PayPoint to determine whether the user's site is part of any\n        beta-version pilot, and therefore determining which version of web\n        pages a user should visit. Persists for the duration of the browser\n        session unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Performance")]),
          _vm._v(" "),
          _c("td", [_vm._v("_ga")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        Allows PayPoint to collect usage metrics from the user, to inform\n        future defect fixes, product enhancements & marketing campaigns.\n        Persists for 2 calendar years unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Strictly Necessary")]),
          _vm._v(" "),
          _c("td", [_vm._v("ASP.NET_SessionID")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        Allows user to login to the website. Persists for duration of browser\n        session unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Performance")]),
          _vm._v(" "),
          _c("td", [_vm._v("_gid")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        We use this to collect usage metrics from users, which helps inform\n        future product enhancements. Expires within 24 hours unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Performance")]),
          _vm._v(" "),
          _c("td", [_vm._v("_gat")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        We use this to collect usage metrics from users, which helps inform\n        future product enhancements. Persists for 1 hour unless deleted.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("PayPoint")]),
          _vm._v(" "),
          _c("td", [_vm._v("Strictly Necessary")]),
          _vm._v(" "),
          _c("td", [_vm._v("Cookies-Consent")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        We will use this cookie to record the consent of the user with the use\n        of other associated cookies, such that a cookies notice can be hidden\n        on future visits to the website, and a user's preference to disable\n        non-essential cookies is recorded for future use.\n      "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }